/**
 * Navbar & Drawer Interactions
 * - Hamburger toggle (mobile)
 * - Drawer open/close
 * - Drawer subnav accordion
 * - Desktop dropdown hover via menu-open class
 */

(function () {
document.addEventListener('DOMContentLoaded', function () {
  const hamburger = document.querySelector('.hamburger');
  const drawer = document.querySelector('.drawer');
  const overlay = document.querySelector('.drawer-overlay');
  const closeBtn = document.querySelector('.drawer-close');
  const toggles = document.querySelectorAll('.drawer-toggle');
  const navItems = document.querySelectorAll('.nav-item.has-children');

  function openDrawer() {
    hamburger.classList.add('active');
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    hamburger.classList.remove('active');
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Hamburger button toggle
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (drawer.classList.contains('active')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  // Overlay click closes drawer
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  // Drawer subnav accordion toggle
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const subnav = this.closest('.drawer-item').querySelector('.drawer-subnav');
      if (subnav) {
        subnav.classList.toggle('expanded');
        this.classList.toggle('expanded');
      }
    });
  });

  // Close drawer when a link is clicked (except toggles)
  const drawerLinks = drawer.querySelectorAll('.drawer-item-header a, .drawer-subnav a, .drawer-utility a');
  drawerLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });

  // Desktop dropdown hover behavior (menu-open class)
  // On hover, add menu-open class to nav-item to show dropdown
  navItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      this.classList.add('menu-open');
    });
    item.addEventListener('mouseleave', function () {
      this.classList.remove('menu-open');
    });
  });

  // Optional: Keyboard support for desktop dropdowns
  // Close dropdown on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      navItems.forEach(function (item) {
        item.classList.remove('menu-open');
      });
    }
  });
});
})();

(function () {
  const toggleBtn = document.querySelector('.nav-search-toggle');
  const panel = document.getElementById('nav-search-panel');
  const closeBtn = panel && panel.querySelector('.search-panel-close');
  const input = panel && panel.querySelector('.search-panel-input');
  const resultsEl = panel && panel.querySelector('[data-search-results]');

  if (!toggleBtn || !panel) return;

  function openSearch() {
    panel.hidden = false;
    toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-open');
    requestAnimationFrame(function () { input && input.focus(); });
  }

  function closeSearch() {
    panel.hidden = true;
    toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('search-open');
    if (resultsEl) { resultsEl.hidden = true; resultsEl.innerHTML = ''; }
  }

  toggleBtn.addEventListener('click', function () {
    panel.hidden ? openSearch() : closeSearch();
  });

  closeBtn && closeBtn.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) closeSearch();
  });

  document.addEventListener('click', function (e) {
    if (!panel.hidden && !panel.contains(e.target) && !toggleBtn.contains(e.target)) {
      closeSearch();
    }
  });

  // Predictive search via Shopify's suggest endpoint
  let debounceTimer;
  input && input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      if (resultsEl) { resultsEl.hidden = true; resultsEl.innerHTML = ''; }
      return;
    }
    debounceTimer = setTimeout(function () { fetchPredictiveResults(query); }, 250);
  });

  function fetchPredictiveResults(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products);
      })
      .catch(function () {});
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function renderResults(products) {
    if (!resultsEl) return;
    if (!products.length) {
      resultsEl.innerHTML = '<p class="search-no-results">No products found.</p>';
      resultsEl.hidden = false;
      return;
    }
    resultsEl.innerHTML = products.map(function (product) {
      const img = product.featured_image && product.featured_image.url
        ? product.featured_image.url.replace(/\.(\w+)(\?.*)?$/, '_80x80.$1$2')
        : '';
      return '<a href="' + product.url + '" class="search-result-item">' +
        (img ? '<img src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '') +
        '<span class="search-result-info">' +
          '<span class="search-result-title">' + escapeHtml(product.title) + '</span>' +
          '<span class="search-result-price">' + escapeHtml(product.price) + '</span>' +
        '</span>' +
      '</a>';
    }).join('');
    resultsEl.hidden = false;
  }
})();